export const formatAbsoluteTime = (absoluteTime: string): string => {
  const date = new Date(absoluteTime);
  return date.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
};
